module.exports = __webpack_public_path__ + "static/media/layers.bd90ab0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/layers.svg
// module id = 503
// module chunks = 98